import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const pageSegmentLoad = createJpdExperience(
	new UFOExperience('jpd.board-view', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

// measure list scroll performance
export const scrollPerformance = createJpdExperience(
	new UFOExperience('jpd.board-view.scroll-performance', {
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	}),
);
